<template>
  <main class="mx-auto max-w-screen-xl p-4">
    <h1 class="text-center">所有關於 「{{ slug }}」的文章</h1>

    <section>
      <!-- Render list of all articles in ./content/blog using `path` -->
      <!-- Provide only defined fieldsin the `:query` prop -->
      <ContentList
        path="/learn"
        :query="{
          only: ['title', 'description', 'tags', '_path', 'image'],
          where: {
            tags: {
              $contains: filter
            }
          },
          $sensitivity: 'base'
        }"
      >
        <!-- Default list slot -->
        <template #default="{ list }">
          <article v-for="article in list" :key="article._path" class="">
            <NuxtLink :to="article._path">
              <div class="flex flex-col md:flex-row">
                <div class="items-center md:basis-2/5">
                  <img
                    :src="article.image"
                    :alt="article.title"
                    class="m-4 w-11/12 rounded-lg h-64 object-cover"
                  />
                </div>
                <div class="m-4 flex flex-col md:basis-3/5">
                  <ul class="flex flex-nowrap gap-4">
                    <li
                      v-for="(tag, n) in article.tags"
                      :key="n"
                      class="rounded-lg bg-orange-400 p-1 text-sm font-semibold text-neutral-50"
                    >
                      {{ tag }}
                    </li>
                  </ul>

                  <h2 class="text-2xl font-bold mt-2">
                    {{ article.title }}
                  </h2>
                  <div class="mb-2">
                    <span class="text-base text-neutral-800">{{ article.publishDate }}</span>
                  </div>
                  <p class="mb-2 font-semibold">
                    {{ article.description }}
                  </p>
                  <div class="flex justify-end">
                    <a
                      class="inline-flex items-center text-base fond-semibold text-blue-700 hover:underline"
                    >
                      閱讀全文

                      <Icon name="material-symbols:keyboard-double-arrow-right" />
                    </a>
                  </div>
                </div>
              </div>
            </NuxtLink>
          </article>
        </template>

        <!-- Not found slot to display message when no content us is found -->
        <template #not-found>
          <p>No articles found.</p>
        </template>
      </ContentList>
    </section>
  </main>
</template>

<script setup>
// const print = (wareev) => {
//   console.log(wareev);
// };

// get current route
const {
  params: { slug }
} = useRoute()

const filter = slug.split(',')

// set meta for page
useHead({
  title: `所有關於 「${slug}」的文章`,
  meta: [
    {
      name: 'description',
      content: `探索所有與 ${slug} 相關的文章和資源`
    }
  ]
})
</script>
